import React from "react";
import PlusSvg from "./UI/svg/PlusSvg";

const BacklogRelate = () => {
  return (
    <>
      <div className="add_backlog_er">
        <input type="text" name="" id="" placeholder="Search ER" />
        <button className="muBtn _blue">
          <span class="svg" style={{ width: "17px" }}>
            <PlusSvg />
          </span>{" "}
          Add to Backlog
        </button>
      </div>
    </>
  );
};

export default BacklogRelate;
